/* eslint-disable */
export default {
  _asapbold: 'asapbold',
  _odin_roundedregular: 'odin_roundedregular',
}